
        
var recurringChargeWidget = function () {
    var firstTimeUrl = document.URL;
    var selectedVariantId = null;
    // define the prototype object and assign properties to it
    var prototype = {
      init: function () {
        this._addFormAttr();
        var currentPageUrl = document.URL;
        var url = new URL(currentPageUrl);
        selectedVariantId = url.searchParams.get("variant");
        this._addVariantChangeListener();
      },
       _handleSellingPlanGroupChange: function (event) {
          let groupRadioEl = event.target;
            var groupId = groupRadioEl.value;
           if(groupId == 0){
             
           }else{
             var sellingPlanId = this._getActiveSellingPlanId(groupId);
             this._setSellingPlanIdInput(sellingPlanId, groupId);
          }
      },
      _handleSellingPlanChange: function (event) {
        groupId = document.querySelector(`input[name=spurit-ros-option]:checked`).value;
        var sellingPlanId = this._getActiveSellingPlanId(groupId);
        this._setSellingPlanIdInput(sellingPlanId, groupId);
        this._addVariantChangeListener();
      },
     _getActiveSellingPlanId: function (groupId) {
          const activePlanInputEl = document.getElementById("recurringChargeSellingPlan-" + groupId);
          const activePlanValue = activePlanInputEl.value;
  
          if (!activePlanInputEl) {
              console.error(`Error - no plan for plangroup ${groupId}.`);
          }
        
          return activePlanValue;
      },
      _updateAllGroupPrices: function(){
        var groups = document.querySelectorAll("input[name=spurit-ros-option]");
        let base = this;
        groups.forEach(function(group){
          var groupId = group.value;
          if(groupId != 0){
            document.querySelector(".recurring_plan_price-" + groupId).textContent = base._getPrice(groupId);
          }
        });
      },
      _setSellingPlanIdInput: function (sellingPlanId, groupId) {
          var sellingPlanIdInput = document.querySelector("#recurringcharge-sellingplan");
          sellingPlanIdInput.value = (typeof sellingPlanId != "undefined") ? sellingPlanId : "";
         document.querySelector(".recurring_plan_price-" + groupId).textContent = this._getPrice(groupId);
      },
      _getPrice: function(groupId){
        const activePlanInputEl = document.getElementById("recurringChargeSellingPlan-" + groupId);
        const selectedOption = activePlanInputEl.options[activePlanInputEl.selectedIndex];
        const selectedOptionDataPrice = selectedOption.dataset.price;
        const selectedOptionDataPriceType = selectedOption.dataset.type;
  
        let prices = this._getOriginalPrice();
  
        return this._calculatePrice(prices, selectedOptionDataPrice, selectedOptionDataPriceType);
        return this._formatRecurringMoney(prices["original"], prices["moneyFormat"]);
        if(selectedOptionDataPrice == ""){
          return this._formatRecurringMoney(prices["original"], prices["moneyFormat"]);
        }else{
          return this._calculatePrice(prices, selectedOptionDataPrice, selectedOptionDataPriceType);
        }  
        return selectedOptionDataPrice;
      },
      // Function to fetch the price based on the selected variant ID
      _fetchVariantPrice() {
        // Find the variant in the data array based on the ID
        var variant = ShopifyAnalytics.meta.product.variants.find(function(variant) {
          return variant.id == selectedVariantId;
        });
  
        // Check if the variant exists
        if (variant) {
          return variant.price;
        } else {
          return null; // Variant not found
        }
      },
      _calculatePrice: function(originalPrice, sellingPlanPrice, priceType){
        let calculatedPrice = parseInt(originalPrice["original"]);
        if (priceType === "percentage") {
          calculatedPrice -= ( originalPrice["original"] * ( parseInt(sellingPlanPrice) / 100));
        } else if (priceType === "fixed_amount") {
          calculatedPrice -= parseInt(sellingPlanPrice);
        } else if (priceType === "price") {
          calculatedPrice = sellingPlanPrice;
        }
        return this._formatRecurringMoney(calculatedPrice, originalPrice["moneyFormat"]);
      },
      _getOriginalPrice: function(){
         const priceEl = document.getElementById("recurringChargePrice");
         let price = [];
         price["original"] = this._fetchVariantPrice();
         price["compare"] = 0;
         price["moneyFormat"] = "";
  
         if(priceEl){
           price["original"] = this._fetchVariantPrice();
           price["compare"] = priceEl.dataset.compareprice;
           price["moneyFormat"] = priceEl.dataset.moneyformat;
         }
  
         return price;
      },
      _formatRecurringMoney: function (cents, moneyFormat) {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = moneyFormat;
  
        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ",";
          decimal = decimal || ".";
  
          if (isNaN(number) || number === null) {
            return 0;
          }
  
          number = (number / 100.0).toFixed(precision);
  
          var parts = number.split(".");
          var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          );
          var centsAmount = parts[1] ? decimal + parts[1] : "";
  
          return dollarsAmount + centsAmount;
        }
  
          switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
              value = formatWithDelimiters(cents, 2);
              break;
            case "amount_no_decimals":
              value = formatWithDelimiters(cents, 0);
              break;
            case "amount_with_comma_separator":
              value = formatWithDelimiters(cents, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              value = formatWithDelimiters(cents, 0, " ");
              break;
            case "amount_with_apostrophe_separator":
              value = formatWithDelimiters(cents, 2, "'");
              break;
          }
          return formatString.replace(placeholderRegex, value);
      },
      _addFormAttr: function(){
        let sectionID = document.getElementsByTagName("section")[0].getAttribute("id");
  
        let filterId = sectionID.replace(/\D/g, "");
        let rcProperties = document.getElementsByClassName("recurringcharge-properties");
        if(rcProperties.length > 0){
          let attrValue = "product-form-template--"+filterId+"__main";		
          for(i=0; i<rcProperties.length; i++){
                rcProperties[i].setAttribute("form", attrValue);
          }
        }	
      },
      
      _detectVariantChange: function () {
        var currentPageUrl = document.URL;
        var url = new URL(currentPageUrl);
        var isVariantUrl = url.searchParams.get("variant");
        currentPageUrl = isVariantUrl ? currentPageUrl :isVariantUrl;
        if(currentPageUrl && firstTimeUrl != currentPageUrl) {
          selectedVariantId = isVariantUrl;
          firstTimeUrl = currentPageUrl;
          this._addVariantChangeListener();
          
        }
      },
      _addVariantChangeListener: function () {
        this._updateAllGroupPrices();
      },
    };
    // assign the prototype to the function name
    return Object.assign(Object.create(prototype), {
      init: function () {
        prototype.init.call(this);
      },
      handleSellingPlanChange: function (event) {
        prototype._handleSellingPlanChange.call(this, event);
      },
      handleSellingPlanGroupChange: function (event) {
        prototype._handleSellingPlanGroupChange.call(this, event);
      },
      getActiveSellingPlanId: function (event) {
        prototype._getActiveSellingPlanId.call(this, event);
      },
      setSellingPlanIdInput: function (event) {
        prototype._setSellingPlanIdInput.call(this, event);
      },
      getPrice: function (event) {
        prototype._getPrice.call(this, event);
      },
      calculatePrice: function (event) {
        prototype._calculatePrice.call(this, event);
      },
      getOriginalPrice: function (event) {
        prototype._getOriginalPrice.call(this, event);
      },
      formatRecurringMoney: function (event) {
        prototype._formatRecurringMoney.call(this, event);
      },
      addFormAttr: function (event) {
        prototype._addFormAttr.call(this, event);
      },
      addVariantChangeListener: function (event) {
        prototype._addVariantChangeListener.call(this, event);
      },
      _detectVariantChange: function (event) {
        prototype._detectVariantChange.call(this, event);
      },
      _updateAllGroupPrices: function (event) {
        prototype._updateAllGroupPrices.call(this, event);
      }
    });
  };
  
  let _freePlanPromo = async () => {
    const response = await fetch("/apps/subscriptions/shop-plan");
    const jsonData = await response.json();
    if(jsonData.data && jsonData.data.plan_id==1){
      let rc_powered_by = document.createElement("a");
      rc_powered_by.setAttribute("href", "https://apps.shopify.com/recurrix-subscription-payments/?utm_medium=poweredby");
      rc_powered_by.setAttribute("target", "_blank");
      rc_powered_by.innerHTML = `Powered By <span style="font-weight: bold;">Recurrix</span>`;
      let poweredEl = document.querySelectorAll(".rucx-powered-by");
      if(poweredEl){
        for(let i=0; i<poweredEl.length; i++){
          let rc_powered_by_clone = rc_powered_by.cloneNode(true);
          poweredEl[i].append(rc_powered_by_clone);
        }
      }
    }
  }
  
  document.addEventListener("DOMContentLoaded", function () {
    window.recurringCharge = window.recurringCharge || {};
    window.recurringCharge.recurringChargeWidget = new recurringChargeWidget();
    window.recurringCharge.recurringChargeWidget.init();
    _freePlanPromo();
  });
  
  document.addEventListener("change", function() {
    window.recurringCharge.recurringChargeWidget._detectVariantChange();
  });
  
  